namespace Matrix.Rebalancer {
    export class ModellingViewFormatColumns {
        static columnsKey = 'Rebalancer.ModellingViewFormat';
    }
}
